import { render, staticRenderFns } from "./SuggestionRow.vue?vue&type=template&id=6b5944d0&scoped=true&"
import script from "./SuggestionRow.vue?vue&type=script&lang=js&"
export * from "./SuggestionRow.vue?vue&type=script&lang=js&"
import style0 from "./SuggestionRow.vue?vue&type=style&index=0&id=6b5944d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5944d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
